<template>
  <div>
    <div class="content-box">
      <p class="p1">
        {{ dataInfo.title }}
      </p>
      <div v-loading="loading" v-html="dataInfo.content"></div>
      <!--   <p class="p1">{{ $t('footerAgreement.title') }}</p>
      <p class="p2">{{ $t('footerAgreement.titleTime') }}</p>
      <p class="p3">
        {{ $t('footerAgreement.titleInfo1') }}
      </p>
      <p class="p4 mt16">
        {{ $t('footerAgreement.titleInfo2') }}
        {{ $t('footerAgreement.titleInfo3') }}
        {{ $t('footerAgreement.titleInfo4') }}
      </p>
      <div class="border1" />
      <p class="p3">{{ $t('footerAgreement.titleInfo5') }}</p>
      <p class="p4 mt16">{{ $t('footerAgreement.titleInfo6') }}</p>
      <p class="p4">
        {{ $t('footerAgreement.titleInfo7') }}
      </p>
      <p class="p5">{{ $t('footerAgreement.titleInfo8') }}</p>
      <p class="p4">
        {{ $t('footerAgreement.titleInfo9') }}</p>
      <p class="p5">{{ $t('footerAgreement.titleInfo10') }}</p>
      <p class="p4">
        {{ $t('footerAgreement.titleInfo11') }}</p>
      <p class="p5">{{ $t('footerAgreement.titleInfo12') }}</p>
      <p class="p4">
        {{ $t('footerAgreement.titleInfo13') }}</p>
      <p class="p5">{{ $t('footerAgreement.titleInfo14') }}</p>
      <p class="p4">
        {{ $t('footerAgreement.titleInfo15') }}</p>
      <p class="p5">{{ $t('footerAgreement.titleInfo16') }}</p>
      <p class="p4">
        {{ $t('footerAgreement.titleInfo17') }}</p>
      <p class="p5">{{ $t('footerAgreement.titleInfo18') }}</p>
      <p class="p4">
        {{ $t('footerAgreement.titleInfo19') }}</p>
      <div class="border1" />
      <p class="p5">{{ $t('footerAgreement.titleInfo20') }}</p>
      <p>
        <span class="p5">{{ $t('footerAgreement.titleInfo21') }}</span>
        <span class="p4">{{ $t('footerAgreement.titleInfo22') }}</span>
      </p>
      <p>
        <span class="p5">{{ $t('footerAgreement.titleInfo23') }}</span>
        <span class="p4">{{ $t('footerAgreement.titleInfo24') }}</span>
      <p class="p6">{{ $t('footerAgreement.titleInfo25') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo26') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo27') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo28') }}</p>
      </p>
      <p class="p4">{{ $t('footerAgreement.titleInfo29') }}</p>
      <p>
        <span class="p5">{{ $t('footerAgreement.titleInfo30') }}</span>
        <span class="p4">{{ $t('footerAgreement.titleInfo31') }}</span>
      <p class="p6">{{ $t('footerAgreement.titleInfo32') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo33') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo34') }}</p>
      </p>
      <p class="p4">{{ $t('footerAgreement.titleInfo35') }}</p>
      <p>
        <span class="p5">{{ $t('footerAgreement.titleInfo36') }}</span>
        <span class="p4">{{ $t('footerAgreement.titleInfo37') }}</span>
      <p class="p6">{{ $t('footerAgreement.titleInfo38') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo39') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo40') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo41') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo42') }}</p>
      </p>
      <p class="p4">{{ $t('footerAgreement.titleInfo43') }}。</p>

      <p class="mt16 p5">{{ $t('footerAgreement.titleInfo44') }}</p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo45') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo46') }}</span>
      </p>
      <p class="p4">{{ $t('footerAgreement.titleInfo47') }}</p>
      <p class="p4">{{ $t('footerAgreement.titleInfo48') }}</p>

      <p class="p5">
        {{ $t('footerAgreement.titleInfo49') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo50') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo51') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo52') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo53') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo54') }}</span>
      </p>
      <p class="p4">
        {{ $t('footerAgreement.titleInfo55') }}
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo56') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo57') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo58') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo59') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo60') }}
      </p>
      <p class="p6">{{ $t('footerAgreement.titleInfo61') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo62') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo63') }}<span
          class="sp1">{{ $t('footerAgreement.titleInfo64') }}</span>{{ $t('footerAgreement.titleInfo65') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo66') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo67') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo68') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo69') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo70') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo71') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo72') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo73') }}</p>
      <p class="p5 mt16">{{ $t('footerAgreement.titleInfo74') }}</p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo75') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo76') }}</span>
      </p>
      <p class="p4">{{ $t('footerAgreement.titleInfo77') }}</p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo78') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo79') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo80') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo81') }}</span>
      </p>
      <p class="p6">{{ $t('footerAgreement.titleInfo82') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo83') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo84') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo85') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo86') }}</p>
      <p class="p5 mt16">{{ $t('footerAgreement.titleInfo87') }}</p>
      <p class="p4">{{ $t('footerAgreement.titleInfo88') }}<span
          class="sp1">{{ $t('footerAgreement.titleInfo89') }}</span>{{ $t('footerAgreement.titleInfo90') }}</p>
      <p class="p4">{{ $t('footerAgreement.titleInfo91') }}</p>
      <p class="p4">{{ $t('footerAgreement.titleInfo92') }}</p>
      <p class="p5">{{ $t('footerAgreement.titleInfo93') }}</p>
      <p class="p5">{{ $t('footerAgreement.titleInfo94') }}</p>
      <p class="p5 mt16">{{ $t('footerAgreement.titleInfo95') }}</p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo96') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo97') }}</span>
      </p>
      <p class="p4">{{ $t('footerAgreement.titleInfo98') }}</p>
      <p class="p5">{{ $t('footerAgreement.titleInfo99') }}</p>
      <p class="p5 mt16">
        {{ $t('footerAgreement.titleInfo100') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo101') }}</span>
      </p>
      <p class="p5">{{ $t('footerAgreement.titleInfo102') }}</p>
      <p class="p5 mt16">{{ $t('footerAgreement.titleInfo103') }}</p>
      <p class="p5 mt16">{{ $t('footerAgreement.titleInfo104') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo105') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo106') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo107') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo108') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo109') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo110') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo111') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo112') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo113') }}</p>
      <p class="p5 mt16">
        {{ $t('footerAgreement.titleInfo114') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo115') }}</span>
      </p>
      <p class="p4">{{ $t('footerAgreement.titleInfo116') }}</p>
      <p class="p4">{{ $t('footerAgreement.titleInfo117') }}</p>
      <p class="p5 mt16">
        {{ $t('footerAgreement.titleInfo118') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo119') }}</span>
      </p>
      <p class="p6">{{ $t('footerAgreement.titleInfo120') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo121') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo122') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo123') }}</p>
      <p class="p5 mt16">{{ $t('footerAgreement.titleInfo124') }}</p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo125') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo126') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo127') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo128') }}</span>
      </p>
      <p class="p6">{{ $t('footerAgreement.titleInfo129') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo130') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo131') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo132') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo133') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo134') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo135') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo136') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo137') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo138') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo139') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo140') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo141') }}</p>
      <p class="p7">{{ $t('footerAgreement.titleInfo142') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo143') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo144') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo145') }}</p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo146') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo147') }}</span>
      </p>
      <p class="p5 mt16">
        {{ $t('footerAgreement.titleInfo148') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo149') }}</span>
      </p>
      <p class="p4">{{ $t('footerAgreement.titleInfo150') }}</p>
      <p class="p4">{{ $t('footerAgreement.titleInfo151') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo152') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo153') }}</p>
      <p class="p6">{{ $t('footerAgreement.titleInfo154') }}</p>
      <p class="p5 mt16">
        {{ $t('footerAgreement.titleInfo155') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo156') }}</span>
      </p>
      <p class="p5 mt16">
        {{ $t('footerAgreement.titleInfo157') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo158') }}</span>
      </p>
      <p class="p5 mt16">{{ $t('footerAgreement.titleInfo159') }}</p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo160') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo161') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo162') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo163') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo164') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo165') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo166') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo167') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo168') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo169') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo170') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo171') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo172') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo173') }}</span>
      </p>
      <p class="p5">
        {{ $t('footerAgreement.titleInfo174') }}
        <span class="p4">{{ $t('footerAgreement.titleInfo175') }}</span>
      </p> -->
    </div>
    <VFooter />
  </div>
</template>

<script>
import { mapState } from "vuex";
import VFooter from "@/components/footer/VFooter";
export default {
  name: "download",
  components: {
    VFooter,
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  data() {
    return {
		loading: false,
      dataInfo: {
        title: '',
        content: ''
      },
    }
  },
  created() {
    this.getDataInfo();
  },
  methods: {
    getDataInfo() {
      const _this = this;
	  this.loading = true;
      this.$axios.post("/cms/getList", {
        page: 1,
        rows: 1,
        cateCode: "terms-use",
      }).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.dataInfo = res.data.data.rows[0] || {};
        }
      }).finally(()=>{
		  this.loading = false;
	  });
    },
  },
};
</script>

<style lang="less" scoped>
.content-box {
  position: relative;
  padding: 120px 260px;
  background-color: #f5f6f7;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(~@/assets/img/images/footer-download.png);

  .mt16 {
    margin-top: 16px;
  }

  .mt60 {
    margin-top: 60px;
  }

  .sp1 {
    color: var(--primary-color);
    text-decoration: underline;
  }

  .border1 {
    width: 100%;
    height: 1px;
    margin: 28px auto;
    background: #707070;
  }

  .p1 {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 36px;
    color: #333333;
    margin-bottom: 60px;
  }

  .p2 {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #666666;
    margin-bottom: 60px;
  }

  .p3 {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 16px;
    color: #1f2329;
  }

  .p4 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #1f2329;
  }

  .p5 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 16px;
    color: #1f2329;
  }

  .p6 {
    margin-left: 28px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #1f2329;
  }

  .p7 {
    margin-left: 42px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #1f2329;
  }
}
</style>
